/* unplugin-vue-components disabled */import { render } from "./test-skills.vue?vue&type=template&id=56841d03&scoped=true"
import script from "./test-skills.vue?vue&type=script&lang=js"
export * from "./test-skills.vue?vue&type=script&lang=js"

import "./test-skills.vue?vue&type=style&index=0&id=56841d03&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56841d03"],['__file',"src/pages/settings/admin/test-skills/test-skills.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56841d03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56841d03', __exports__)) {
    api.reload('56841d03', __exports__)
  }
  
  module.hot.accept("./test-skills.vue?vue&type=template&id=56841d03&scoped=true", () => {
    api.rerender('56841d03', render)
  })

}


export default __exports__